import { useRef, useState } from "react";
import Tooltip from "../tooltip/tooltip";
import { HelpCircle } from "lucide-react";


export default function ToolTipQuestionMark({tooltip}) {
    const ref = useRef(null)
    const [showTooltip, setShowTooltip] = useState(false);
    
  return (
    <>
      <HelpCircle
        ref={ref}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="w-[13px] ml-1 h-[15px] mx-2 cursor-pointer"
        />

        {tooltip && (
        <Tooltip
            anchorRef={ref}
          text={tooltip}
          visible={showTooltip}
        />
      )}
    </>
  )
}
